import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {DomSanitizer, Title} from '@angular/platform-browser';
import localeEnGB from '@angular/common/locales/en-GB';
import localeEnUS from '@angular/common/locales/en';
import localeFrFR from '@angular/common/locales/fr';
import {registerLocaleData, TitleCasePipe} from '@angular/common';
import {ConfigService} from './services/config/config.service';
import {TranslateService} from '@ngx-translate/core';
import {UserInfoStorageService} from './services/auth/user-info-storage.service';
import {Locale} from './utils/locale';
import {CrystalAvailabilityService} from './services/crystal-availability.service';
import {AppConfigService} from "./services/app-config.service";
import {CcCookieMigrationService} from "./services/common/cc-cookie-migration.service";

registerLocaleData(localeEnGB);
registerLocaleData(localeEnUS);
registerLocaleData(localeFrFR);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers:
    [
      ConfigService,
      TitleCasePipe
    ]
})
export class AppComponent implements OnInit {
  public title = 'CrystalClear';
  public isCrystalClearAvailable: boolean = true;
  public isCrystalClearHubServiceAvailable: boolean = true;
  public isCrystalClearArchiveServiceAvailable: boolean = true;
  public static focusTableMouseOver: boolean = false;

  constructor(private authService: UserInfoStorageService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private titleService: Title,
              private domSanitizer: DomSanitizer,
              private translateService: TranslateService,
              public crystalAvailabilityService: CrystalAvailabilityService,
              public appConfigService: AppConfigService,
              cookieMigrationService: CcCookieMigrationService) {
    cookieMigrationService.migrate();
    this.translateService.addLangs([Locale.LANGS.EN_GB.id]);//, Locale.LANGS.EN_US.id, Locale.LANGS.FR_FR.id]);
    this.translateService.setDefaultLang(Locale.LANGS.EN_GB.id);
    this.translateService.use(this.authService.lang);

    this.title = appConfigService.webTitle;
    if (this.title)
      this.titleService.setTitle(this.title);
    AppComponent.focusTableMouseOver = appConfigService.focusTableMouseOver;

    this.crystalAvailabilityService.isCrystalClearAvailableEmitter.subscribe(isCrystalAvailable => {
      if (!this.isCrystalClearAvailable && isCrystalAvailable) {
        location.reload();
      } else {
        this.isCrystalClearAvailable = isCrystalAvailable;
      }
    });

    this.crystalAvailabilityService.isCrystalClearHubServiceAvailableEmitter.subscribe(isCrystalAvailable => {
      if (!this.isCrystalClearHubServiceAvailable && isCrystalAvailable && this.isCrystalClearArchiveServiceAvailable) {
        location.reload();
      } else {
        this.isCrystalClearHubServiceAvailable = isCrystalAvailable;
      }
    });

    this.crystalAvailabilityService.isCrystalClearArchiveServiceAvailableEmitter.subscribe(isCrystalAvailable => {
      if (!this.isCrystalClearArchiveServiceAvailable && isCrystalAvailable && this.isCrystalClearHubServiceAvailable) {
        location.reload();
      } else {
        this.isCrystalClearArchiveServiceAvailable = isCrystalAvailable;
      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute.snapshot),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      map(route => route.data)
    )
      .subscribe((data) => {
        if (data.title)
          this.titleService.setTitle([this.title, this.translateService.instant(data.title)].filter(Boolean).join(' - '));
      });
  }

  ngOnInit() {
  }

  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    if (this.appConfigService.logoutOnClose) {
      this.authService.logoutOnUnload();
    }
  }
}
